import PortalLayout from '@portal/PortalLayout';
import { Outlet } from 'react-router-dom';
import AppShell from '../common/AppShell/AppShell';

const Portal = () => {
  return (
    <AppShell translationRoot="portal">
      <PortalLayout>
        <Outlet />
      </PortalLayout>
    </AppShell>
  );
};

export default Portal;
